<template>
  <div class="home">
    <div class="header">
      <div class="headerlogo">
        <router-link to="/">
          <h1>澄安科技企業社 Cheng An Technology Enterpries</h1>
          <!-- <img class="logo" src="@/assets/logo.png" /> -->
        </router-link>
      </div>
      <div class="menudiv">
        <el-menu
          class="menu"
          default-active="1"
          mode="horizontal"
          background-color="transparent"
          active-text-color="#f4d271"
        >
          <el-menu-item
            class="elmenuitem"
            v-for="(route, routeIndex) in routes"
            :key="routeIndex"
            :index="route.index"
            @click.native="jump(routeIndex)"
          >
            <div class="menuitem">
              {{ route.name }}
              <br />
              <span class="menuitemspan">{{ route.enName }}</span>
            </div>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="d_jump">
      <div class="large_about">
        <div class="large_abouttext">
          <div class="large_abouttitle">關於我們</div>
          <div class="large_aboutrow">
            <div class="large_aboutcontent1">
              <div class="large_aboutslogan">Operating&nbsp;&nbsp;經營</div>
              <br />熱忱、態度是我們對客戶的心
              <br />服務、專業是我們對工作的理念 <br />運用我們的專業
              <br />規劃給客戶最好的安全環境
              <br />
            </div>
            <div class="large_aboutcontent2">
              <div class="large_aboutslogan">Service&nbsp;&nbsp;服務</div>
              <br />依照客戶的需求 <br />規劃設計一套安全的監視器系統
              <br />給予客戶專屬客製的服務 <br />我們提供客戶完善的售後服務
              <br />給予客戶第一時間的協助
            </div>
          </div>
        </div>
      </div>
      <div class="about">
        <el-carousel height="480px">
          <el-carousel-item>
            <div class="aboutcarousel aboutimg1">
              <div class="abouttext">
                <div class="abouttitle">關於我們</div>
                <div class="aboutrow">
                  <div class="aboutcontent1">Service&nbsp;&nbsp;服務</div>
                  <div class="aboutcontent2">
                    <br />依照客戶的需求 <br />規劃設計一套安全的監視器系統
                    <br />給予客戶專屬客製的服務
                    <br />我們提供客戶完善的售後服務
                    <br />給予客戶第一時間的協助
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="aboutcarousel aboutimg2">
              <div class="abouttext">
                <div class="abouttitle">關於我們</div>
                <div class="aboutrow">
                  <div class="aboutcontent1">Operating&nbsp;&nbsp;經營</div>
                  <div class="aboutcontent2">
                    <br />熱忱、態度是我們對客戶的心
                    <br />服務、專業是我們對工作的理念 <br />運用我們的專業
                    <br />規劃給客戶最好的安全環境
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="servies d_jump" id="servies">
      <div class="serviestext">
        <div class="serviestitle">服務項目</div>
        <div class="serviesrow">
          <el-card
            class="card"
            shadow="hover"
            :body-style="{ padding: '0px', width: '100%' }"
            v-for="(value, index) in serviesModel"
            :key="index"
          >
            <div class="serviescard">
              <div class="serviesimg">
                <img
                  class="serviesicon"
                  :src="value.icon"
                  :title="value.title"
                  :alt="value.title"
                />
              </div>
              <div class="serviescardtext">
                <h3 class="serviescardtitle">{{ value.title }}</h3>
                <div
                  class="serviescardcontent"
                  v-html="value.introduction"
                ></div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <div class="product d_jump" id="product">
      <div class="producttext">
        <div class="producttitle">產品介紹</div>
        <div class="productcontent">
          <div
            class="productcardcarddiv"
            shadow="hover"
            v-for="(productValue, productIndex) in productModel"
            :key="productIndex"
          >
            <img
              class="producticon"
              :src="productValue.icon"
              :alt="productValue.title"
              :title="productValue.title"
            />
            <h3 class="productcardtitle">{{ productValue.title }}</h3>
          </div>
        </div>
        <router-link to="/product">
          <div class="productmore">
            查看更多產品介紹
            <i class="el-icon-caret-right"></i>
          </div>
        </router-link>
      </div>
    </div>
    <div class="contact d_jump" id="content"></div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      routes: [
        {
          index: "1",
          idName: "menuabout",
          name: "關於我們",
          enName: "About Us",
        },
        {
          index: "2",
          idName: "menuservies",
          name: "服務項目",
          enName: "Servies",
        },
        {
          index: "3",
          idName: "menuproduct",
          name: "產品介紹",
          enName: "Product",
        },
        {
          index: "4",
          idName: "menucontact",
          name: "聯絡我們",
          enName: "Contact",
        },
      ],
      serviesModel: [
        {
          icon: require("@/assets/monitor.svg"),
          title: "監視器系統",
          introduction: "給予居家、店家及公司<br>完善的安全保障",
        },
        {
          icon: require("@/assets/door.svg"),
          title: "門禁系統",
          introduction: "使用專屬感應卡辨識身分<br>避免外人進入",
        },
        {
          icon: require("@/assets/cargate.svg"),
          title: "e-Tag車輛管制系統",
          introduction:
            "辨識住家大樓車輛資料<br>防止外來車輛進入社區<br>確保住戶安危",
        },
        {
          icon: require("@/assets/internet.svg"),
          title: "網路規劃系統",
          introduction:
            "規劃與施工<br>店家及公司所需網路之佈線<br>讓營運不再延遲<br>與客戶縮短距離",
        },
        {
          icon: require("@/assets/intercom.svg"),
          title: "對講機系統",
          introduction:
            "訪客進入社區便利管理人員<br>聯繫住戶及包裹領取<br>減少傳遞時間",
        },
        {
          icon: require("@/assets/trafficlight.svg"),
          title: "車道安全系統",
          introduction:
            "建置大樓車道紅綠燈<br>防止住戶進出入車道發生危險<br>透過柵欄機預防外來車輛<br>直接進入社區",
        },
      ],
      productModel: [
        {
          icon: require("@/assets/camera.svg"),
          title: "高畫質攝影機",
        },
        {
          icon: require("@/assets/dvr.svg"),
          title: "DVR監控主機",
        },
        {
          icon: require("@/assets/cardmachine.svg"),
          title: "門禁刷卡機",
        },
      ],
    };
  },
  methods: {
    jump(index) {
      // 用 class="d_jump" 添加锚点
      let jump = document.querySelectorAll(".d_jump");
      let total = jump[index].offsetTop;
      //console.log(total);
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }
      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
}
.header {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 5;
  background: url("../assets/title.jpg") center center no-repeat;
  background-size: cover;
}
.headerlogo {
  width: 183px;
  height: 100%;
  position: relative;
  left: 10px;
  background-image: url("../assets/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position:50%;
  h1 {
    text-indent: 101%;
    overflow: hidden;
    white-space: nowrap;
  }
}
.logo {
  width: 100%;
}
.menudiv {
  position: absolute;
  right: 0;
  bottom: 0;
}
.elmenuitem {
  width: 25%;
}
.menuitem {
  font-size: 1.3em !important;
  text-align: center;
  line-height: 15px;
  position: relative;
  top: 15px;
  color: #ffffff;
}
a {
  text-decoration: none;
}
.menuitemspan {
  font-size: 0.8em !important;
  color: rgb(136, 136, 136);
}
.el-menu.el-menu--horizontal {
  border-bottom: 0 !important;
}
/*關於我們 */
.large_about {
  width: 100%;
  height: 480px;
  z-index: 4;
  background: url("../assets/aboutimg_large.png");
  background-size: cover;
}
.large_abouttext {
  width: 80%;
  margin: auto;
  position: relative;
  top: 70px;
  z-index: 2;
}
.large_abouttitle {
  z-index: 1;
  font-weight: bold;
  font-size: 1.7em;
  color: rgb(218, 218, 218);
  margin-bottom: 30px;
}
.large_aboutrow {
  width: 100%;
  height: 100px;
  display: flex;
  color: rgb(255, 255, 255);
  font-size: 1.25em;
}
.large_aboutcontent1,
.large_aboutcontent2 {
  width: 40%;
  line-height: 30pt;
}
.large_aboutcontent1 {
  position: absolute;
  left: 0;
}
.large_aboutcontent2 {
  position: absolute;
  right: 40px;
}
.large_aboutslogan {
  height: 10px;
  color: #f4d271;
}
.about {
  display: none;
}

/*服務項目 */
.servies {
  width: 100%;
  height: 680px;
}
.serviestext {
  width: 80%;
  height: 620px;
  margin: auto;
  position: relative;
  top: 70px;
  z-index: 3;
}
.serviestitle {
  z-index: 1;
  font-weight: bold;
  font-size: 1.7em;
  color: #414141;
  margin-bottom: 30px;
}
.serviesrow {
  width: 100%;
  height: 550px;
  display: grid;
  grid-template-columns: repeat(3, 30.5%);
  grid-template-rows: repeat(2, 200px);
  grid-column-gap: 4%;
  grid-row-gap: 50px;
}
.card {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.card:hover {
  background-color: #e0e0e0;
}
.serviescard {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
}
.serviesimg {
  width: 120px;
  height: 120px;
  margin-left: 20px;
}
.serviesicon {
  width: 90%;
  height: 90%;
}
.serviescardtext {
  flex: 1;
  height: 100%;
}
.serviescardtitle {
  width: 100%;
  font-weight: bold;
  font-size: 1.25em;
  position: relative;
  left: 15px;
  margin: 0;
}
.serviescardcontent {
  position: relative;
  left: 15px;
  top: 10px;
}
/*產品介紹 */ 
.product {
  width: 100%;
  height: 450px;
  background-color: #ffffff;
}
.producttext {
  width: 80%;
  height: 380px;
  margin: auto;
  position: relative;
  top: 70px;
  z-index: 2;
}
.producttitle {
  z-index: 1;
  font-weight: bold;
  font-size: 1.7em;
  color: #636363;
  margin-bottom: 30px;
}
.productcontent {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 30.5%);
  grid-column-gap: 4%;
}
.productcardcarddiv {
  width: 100%;
  height: 200px;
  background-color: #e8e8e8;
  text-align: center;
}
.productcardcarddiv:hover {
  background-color: #d1d1d1;
}
.producticon {
  width: 100px;
  position: relative;
  top: 25px;
}
.productcardtitle {
  margin: 40px 0 0 0;
  text-align: center;
  font-size: 1.25em;
  font-weight: normal;
}
.productmore {
  width: 250px;
  height: 44px;
  line-height: 44px;
  position: absolute;
  right: 0;
  bottom: 30px;
  text-align: right;
  padding-right: 15px;
  background-color: #636363;
  color: #f4d271;
  border-radius: 20px;
}
.productmore:hover {
  opacity: 0.8;
}
.phone_address {
  color: #ffffff;
}
.phone_address:hover {
  color: #cea945;
}
@media screen and (max-width: 1500px) {
  .servies {
    height: 900px;
  }
  .serviesrow {
    display: grid;
    grid-template-columns: repeat(2, 48%);
    grid-template-rows: repeat(3, 200px);
    grid-column-gap: 4%;
    grid-row-gap: 50px;
  }
}
@media screen and (max-width: 1000px) {
  .servies {
    height: 1450px;
  }
  .serviesrow {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: repeat(6, 180px);
    grid-row-gap: 30px;
  }
  .serviescardtitle {
    width: 230px;
    margin: auto;
  }
  .serviescardcontent {
    width: 230px;
    margin: auto;
  }
  .contactcontent {
    width: 100%;
    height: 150px;
    display: block;
  }
}
@media screen and (max-width: 767px) {
  
/*關於我們 */
  .large_about {
    display: none;
  }
  .about {
    display: block;
  }
  .abouttitle,
  .serviestitle,
  .producttitle,
  .contacttitle {
    font-size: 1.3em;
  }
  .aboutimg1 {
    width: 100%;
    height: 100%;
    background: url("../assets/aboutimg.png");
    background-size: cover;
  }
  .aboutimg2 {
    width: 100%;
    height: 100%;
    background: url("../assets/aboutimg2.png");
    background-size: cover;
  }
  .aboutcarousel {
    width: 100%;
    height: 100%;
  }
  .abouttext {
    width: 80%;
    margin: auto;
    position: relative;
    top: 70px;
    z-index: 2;
  }
  .abouttitle {
    z-index: 1;
    font-weight: bold;
    font-size: 1.3em;
    color: rgb(218, 218, 218);
    margin-bottom: 20px;
  }
  .aboutrow {
    width: 100%;
    color: rgb(255, 255, 255);
    font-size: 1em;
  }
  .aboutcontent1,
  .aboutcontent2 {
    line-height: 30pt;
  }
  .aboutcontent1 {
    width: 100%;
    height: 40px;
    color: #d1b741;
    border-bottom: 1px solid #d1b741;
  }
  .headerlogo {
    margin: auto;
    position: static;
  }
  .menudiv {
    width: 100%;
    background-color: rgb(58, 58, 58);
    border-top: 1px solid rgb(114, 114, 114);
    position: fixed;
    bottom: 0;
  }
  .menu {
    width: 100%;
  }
  .elmenuitem {
    width: 25%;
    font-size: 0.7em !important;
  }
  .menuitemspan {
    font-size: 0.8em !important;
    color: rgb(136, 136, 136);
  }
  .card:hover {
    background-color: #ffffff;
  }
  
/*服務項目 */
  .servies {
    height: 1100px;
  }
  .serviesrow {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: repeat(6, 130px);
    grid-row-gap: 30px;
  }
  .serviesimg {
    width: 80px;
    height: 80px;
  }
  .serviesicon {
    width: 100%;
    height: 100%;
    padding-left: 2px;
  }
  .serviescardtitle {
    width: 180px;
    font-size: 1em;
    position: relative;
    left: 5px;
    top: 15px;
  }
  .serviescardcontent {
    width: 180px;
    font-size: 0.8em;
    position: relative;
    left: 5px;
    top: 18px;
  }
  
/*產品介紹 */
  .product {
    height: 780px;
    background-color: #ffffff;
  }
  .producttext {
    height: 700px;
  }
  .productcontent {
    display: block;
    height: 650px;
  }
  .productcardtitle {
    margin-top: 40px;
    text-align: center;
    font-size: 1em;
  }
  .productcardcarddiv {
    width: 100%;
    height: 160px;
    margin-bottom: 20px;
  }
  .productcardcarddiv:hover {
    background-color: #e8e8e8;
  }
  .producticon {
    width: 80px;
  }
}
@media screen and (max-width: 380px) {
  .serviesimg {
    width: 60px;
    height: 60px;
    margin-left: 12px;
  }
  .productmore {
    width: 90%;
  }
}
@media screen and (max-width: 320px) {
  .serviesimg {
    width: 55px;
    height: 55px;
    margin-left: 7px;
  }
  .serviescardtitle {
    font-size: 0.8em;
  }
  .serviescardcontent {
    font-size: 0.6em;
  }
}
</style>
